'use strict';
const angular = require('angular');

export class mapComponent {

  constructor($timeout) {
    'ngInject';

    this.$timeout = $timeout;
  }

  $onInit() {

    let _zoom = this.zoom ? parseInt(this.zoom, 10) : 15;

    this.mapOptions = {
      zoom: _zoom,
      center: new google.maps.LatLng(this.lat, this.lng),
      mapTypeId: google.maps.MapTypeId.TERRAIN
    };

    this.$timeout(() => {
      this.map = new google.maps.Map(document.getElementById('gMap'), this.mapOptions);

      var marker = new google.maps.Marker({
        map: this.map,
        position: new google.maps.LatLng(this.lat, this.lng),
        title: this.address
      });

      marker.content = '<div class="infoWindowContent">' + this.address + '</div>';

    },500);
  }
}

export default angular.module('conduuApp.map', [])
  .component('map', {
    template: '<div id="gMap" style="height:{{$ctrl.height}}"></div>',
    bindings: {
      height: '@',
      address: '@',
      lat: '@',
      lng: '@',
      zoom: '@'
    },
    controller: mapComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/map/map.component.js